/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManageBasketItemCommand } from '../../models/manage-basket-item-command';
import { ManageBasketItemCommandResult } from '../../models/manage-basket-item-command-result';

export interface ApiNurseryManagerBasketManageBasketItemsPost$Params {
      body?: ManageBasketItemCommand
}

export function apiNurseryManagerBasketManageBasketItemsPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerBasketManageBasketItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageBasketItemCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerBasketManageBasketItemsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManageBasketItemCommandResult>;
    })
  );
}

apiNurseryManagerBasketManageBasketItemsPost.PATH = '/api/NurseryManager/Basket/ManageBasketItems';
